import React, { useState, useEffect, Suspense, lazy } from "react";
import { Grid, Box, CircularProgress } from "@mui/material";
import ChargebackRatio from "./DashboardComponents/ChargebackRatio";

const SalesOverview = lazy(() => import("./DashboardComponents/SalesOverview"));
const FlipCard = lazy(() => import("./DashboardComponents/FlipCards"));
const Wave = lazy(() => import("./DashboardComponents/Wave"));
const Deposits = lazy(() => import("./DashboardComponents/Deposits"));
const Refund = lazy(() => import("./DashboardComponents/Refund"));
const DailyTransaction = lazy(() => import("./DashboardComponents/DailyTransaction"));
const CurrencyDeposits = lazy(() => import("./DashboardComponents/CurrencyDeposits"));
const TopTransactions = lazy(() => import("./DashboardComponents/TopTransactions"));

const Dashboard1 = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box>
      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          
        >
          <CircularProgress size={60} sx={{
            marginBottom: "20%"
          }} />
        </Box>
      ) : (
        <Suspense
          fallback={
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress size={50} />
            </Box>
          }
        >
          <Grid container spacing={2}>
            {/* ------------------------- row 1 ------------------------- */}
            <Grid item xs={12} lg={4}>
              <FlipCard />
            </Grid>
            <Grid item xs={6} lg={1}>
              <Wave />
            </Grid>
            <Grid item xs={6} lg={1}>
              <ChargebackRatio />
            </Grid>
            <Grid item lg={6}>
              <Grid container direction="column" spacing={2}>
                <Grid item xs={6}>
                  <Deposits />
                </Grid>
                <Grid item xs={6}>
                  <Refund />
                </Grid>
              </Grid>
            </Grid>
            {/* ------------------------- row 2 ------------------------- */}
            <Grid item xs={12} lg={6}>
              <SalesOverview />
            </Grid>
            <Grid item xs={12} lg={6}>
              <DailyTransaction />
            </Grid>
            {/* ------------------------- row 3 ------------------------- */}
            <Grid item xs={12} lg={6}>
              <CurrencyDeposits />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TopTransactions />
            </Grid>
          </Grid>
        </Suspense>
      )}
    </Box>
  );
};

export default Dashboard1;
